import Skeleton from 'react-loading-skeleton';
import { emptyArray } from '~/utils/helpers';
import Profiles from '~/view/containers/ProfilesList/components/ProfilesWrapper/ProfilesWrapper';
import { Profile } from '~/view/containers/ProfilesList/components/Profile/Profile';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import { TProfile } from '~/view/containers/ProfilesList';

type Props = {
  loading?: boolean;
  profiles?: TProfile[];
  selectProfile: (profile: TProfile) => void;
  onUpdateName?: (profile: TProfile) => Promise<boolean | undefined> | boolean | undefined;
  selectedProfileId?: number | null;
  onAddProfile?: () => void;
  wrapperClassName?: string;
};

export const ProfilesScrollableList = (props: Props) => (
  <Profiles onAddProfile={props.onAddProfile} wrapperClassName={props.wrapperClassName}>
    <ScrollableBlock className="profiles-list__container" scrollClassName="profiles-list__scroll pr-1" showScrollbar>
      <ul className="d-flex flex-column gap-10">
        {props.loading
          ? emptyArray(4).map((_, index) => <Skeleton key={index} width={210} height={54} style={{ borderRadius: 14 }} />)
          : props.profiles?.map((profile: TProfile) => <Profile key={profile.id} profile={profile} {...props} />)}
      </ul>
    </ScrollableBlock>
  </Profiles>
);
